import {
  CampaignFragment as LegacyCampaignFragment,
  CampaignLineFragment as LegacyCampaignLineFragment,
  CardFragment as LegacyCardFragment,
  CardPaperType as LegacyCardPaperType,
  CardSendType as LegacyCardSendType,
  CardType as LegacyCardType,
  Currency as LegacyCurrency,
  CurrencyType as LegacyCurrencyType,
  DetailedOrderFragment as LegacyDetailedOrderFragment,
  ElementFragment as LegacyElementFragment,
  ElementTextFragment as LegacyElementTextFragment,
  GiftVariationFragment as LegacyGiftVariationFragment,
  ItemCategoryFragment as LegacyItemCategoryFragment,
  ItemFragment as LegacyItemFragment,
  ItemizedCostFragment as LegacyItemizedCostFragment,
  LabeledPriceFragment as LegacyLabeledPriceFragment,
  LayoutCategory as LegacyLayoutCategory,
  LayoutDimensions as LegacyLayoutDimensions,
  LayoutFragment as LegacyLayoutFragment,
  LineFragment as LegacyLineFragment,
  Owner as LegacyOwner,
  PanelFragment as LegacyPanelFragment,
  ParagraphFragment as LegacyParagraphFragment,
  PriceFragment as LegacyPriceFragment,
  SendableCardFragment as LegacySendableCardFragment,
  SendableCardWithTemplateFragment as LegacySendableCardWithTemplateFragment,
  SendDelayDelayType as LegacySendDelayDelayType,
  SendDelayFragment as LegacySendDelayFragment,
  SendDelayTimeType as LegacySendDelayTimeType,
  SendDelayType as LegacySendDelayType,
  TextAlignment as LegacyTextAlignment,
} from 'src/legacy_graphql'
import {
  CampaignFragment,
  CampaignLineFragment,
  CardFragment,
  CardPaperType,
  CardSendType,
  CardType,
  Currency,
  CurrencyType,
  DetailedOrderFragment,
  ElementFragment,
  ElementTextFragment,
  GiftVariationFragment,
  ItemCategoryFragment,
  ItemFragment,
  ItemizedCostFragment,
  LabeledPriceFragment,
  LayoutCategory,
  LayoutDimensions,
  LayoutFragment,
  LineFragment,
  Owner,
  PanelFragment,
  ParagraphFragment,
  PriceFragment,
  SendableCardFragment,
  SendableCardWithTemplateFragment,
  SendDelayDelayType,
  SendDelayFragment,
  SendDelayTimeType,
  SendDelayType,
  TextAlignment,
} from 'src/graphql/generated/graphql'

export const currencyFromLegacy = (legacy: LegacyCurrency): Currency => {
  switch (legacy) {
    case LegacyCurrency.SOC:
      return Currency.Soc
    case LegacyCurrency.UNAVAILABLE:
      return Currency.Unavailable
    case LegacyCurrency.USD:
      return Currency.Usd
  }
}

export const currencyToLegacy = (next: Currency): LegacyCurrency => {
  switch (next) {
    case Currency.Soc:
      return LegacyCurrency.SOC
    case Currency.Unavailable:
      return LegacyCurrency.UNAVAILABLE
    case Currency.Usd:
      return LegacyCurrency.USD
  }
}

export const currencyTypeFromLegacy = (
  legacy: LegacyCurrencyType,
): CurrencyType => {
  switch (legacy) {
    case LegacyCurrencyType.CARDTOKEN:
      return CurrencyType.Cardtoken
    case LegacyCurrencyType.CREDIT:
      return CurrencyType.Credit
    case LegacyCurrencyType.EXPENSE:
      return CurrencyType.Expense
    case LegacyCurrencyType.FREE:
      return CurrencyType.Free
    case LegacyCurrencyType.POINT:
      return CurrencyType.Point
    case LegacyCurrencyType.USD:
      return CurrencyType.Usd
  }
}

export const giftVariationFragmentFromLegacy = (
  giftVariation: LegacyGiftVariationFragment,
): GiftVariationFragment => {
  return {
    ...giftVariation,
    points: {
      ...giftVariation.points,
      currency: currencyFromLegacy(giftVariation.points.currency),
    },
    price: {
      ...giftVariation.price,
      currency: currencyTypeFromLegacy(giftVariation.price.currency),
    },
  }
}

export const cardTypeFromLegacy = (legacy: LegacyCardType): CardType => {
  switch (legacy) {
    case LegacyCardType.FLATCARD:
      return CardType.Flatcard
    case LegacyCardType.POSTCARD:
      return CardType.Postcard
    case LegacyCardType.THREE_PANEL:
      return CardType.ThreePanel
    case LegacyCardType.TWO_PANEL:
      return CardType.TwoPanel
    case LegacyCardType.TWO_PANEL_BIG:
      return CardType.TwoPanelBig
  }
}

export const cardPaperTypeFromLegacy = (
  legacy: LegacyCardPaperType,
): CardPaperType => {
  switch (legacy) {
    case LegacyCardPaperType.HVY:
      return CardPaperType.Hvy
    case LegacyCardPaperType.PRE:
      return CardPaperType.Pre
    case LegacyCardPaperType.STD:
      return CardPaperType.Std
  }
}

export const sendDelayTypeFromLegacy = (
  legacy: LegacySendDelayType,
): SendDelayType => {
  switch (legacy) {
    case LegacySendDelayType.ANN:
      return SendDelayType.Ann
    case LegacySendDelayType.BIR:
      return SendDelayType.Bir
    case LegacySendDelayType.IMM:
      return SendDelayType.Imm
    case LegacySendDelayType.SPE:
      return SendDelayType.Spe
  }
}

export const sendDelayDelayTypeFromLegacy = (
  legacy: LegacySendDelayDelayType,
): SendDelayDelayType => {
  switch (legacy) {
    case LegacySendDelayDelayType.DAY:
      return SendDelayDelayType.Day
    case LegacySendDelayDelayType.MON:
      return SendDelayDelayType.Mon
    case LegacySendDelayDelayType.WEE:
      return SendDelayDelayType.Wee
  }
}

export const sendDelayTimeTypeFromLegacy = (
  legacy: LegacySendDelayTimeType,
): SendDelayTimeType => {
  switch (legacy) {
    case LegacySendDelayTimeType.AFT:
      return SendDelayTimeType.Aft
    case LegacySendDelayTimeType.BEF:
      return SendDelayTimeType.Bef
  }
}

export const sendDelayFragmentFromLegacy = (
  sendDelayFragment: LegacySendDelayFragment,
): SendDelayFragment => {
  return {
    ...sendDelayFragment,
    type: sendDelayTypeFromLegacy(sendDelayFragment.type),
    delayType: sendDelayDelayTypeFromLegacy(sendDelayFragment.delayType),
    timeType: sendDelayTimeTypeFromLegacy(sendDelayFragment.timeType),
  }
}

export const campaignLineFragmentFromLegacy = (
  campaignLineFragment: LegacyCampaignLineFragment,
): CampaignLineFragment => {
  return {
    ...campaignLineFragment,
    card: campaignLineFragment.card
      ? {
          ...campaignLineFragment.card,
          type: cardTypeFromLegacy(campaignLineFragment.card.type),
          paperType: cardPaperTypeFromLegacy(
            campaignLineFragment.card.paperType,
          ),
        }
      : undefined,
    giftVariation:
      campaignLineFragment.giftVariation &&
      giftVariationFragmentFromLegacy(campaignLineFragment.giftVariation),
    sendDelay: sendDelayFragmentFromLegacy(campaignLineFragment.sendDelay),
  }
}

export const campaignFragmentFromLegacy = (
  campaignFragment: LegacyCampaignFragment,
): CampaignFragment => {
  return {
    ...campaignFragment,
    lines: campaignFragment.lines.map(campaignLineFragmentFromLegacy),
  }
}

export const itemFragmentFromLegacy = (
  itemFragment: LegacyItemFragment,
): ItemFragment => {
  return {
    ...itemFragment,
    campaign: itemFragment.campaign
      ? campaignFragmentFromLegacy(itemFragment.campaign)
      : undefined,
  }
}

export const itemCategoryFromLegacy = (
  category: LegacyItemCategoryFragment,
): ItemCategoryFragment => {
  return {
    ...category,
    items: category.items.map(itemFragmentFromLegacy),
  }
}

export const layoutDimensionsToLegacy = (
  next: LayoutDimensions,
): LegacyLayoutDimensions => {
  switch (next) {
    case LayoutDimensions.Horizontal:
      return LegacyLayoutDimensions.HORIZONTAL
    case LayoutDimensions.Postcard:
      return LegacyLayoutDimensions.POSTCARD
    case LayoutDimensions.Vertical:
      return LegacyLayoutDimensions.VERTICAL
  }
}

export const layoutDimensionsFromLegacy = (
  legacy: LegacyLayoutDimensions,
): LayoutDimensions => {
  switch (legacy) {
    case LegacyLayoutDimensions.HORIZONTAL:
      return LayoutDimensions.Horizontal
    case LegacyLayoutDimensions.POSTCARD:
      return LayoutDimensions.Postcard
    case LegacyLayoutDimensions.VERTICAL:
      return LayoutDimensions.Vertical
  }
}

export const layoutCategoryFromLegacy = (
  legacy: LegacyLayoutCategory,
): LayoutCategory => {
  switch (legacy) {
    case LegacyLayoutCategory.BACK_PANELS:
      return LayoutCategory.BackPanels
    case LegacyLayoutCategory.BASIC_LAYOUTS:
      return LayoutCategory.BasicLayouts
  }
}

export const ownerFromLegacy = (legacy: LegacyOwner): Owner => {
  switch (legacy) {
    case LegacyOwner.SYSTEM:
      return Owner.System
    case LegacyOwner.USER:
      return Owner.User
  }
}

export const textAlignmentFromLegacy = (
  legacy: LegacyTextAlignment,
): TextAlignment => {
  switch (legacy) {
    case LegacyTextAlignment.CENTER:
      return TextAlignment.Center
    case LegacyTextAlignment.LEFT:
      return TextAlignment.Left
    case LegacyTextAlignment.RIGHT:
      return TextAlignment.Right
  }
}

export const paragraphFragmentFromLegacy = (
  legacy: LegacyParagraphFragment,
): ParagraphFragment => {
  return {
    ...legacy,
    alignment: textAlignmentFromLegacy(legacy.alignment),
  }
}

export const elementTextFragmentFromLegacy = (
  legacy: LegacyElementTextFragment,
): ElementTextFragment => {
  return {
    ...legacy,
    paragraphs: legacy.paragraphs.map(paragraphFragmentFromLegacy),
  }
}

export const elementFragmentFromLegacy = (
  legacy: LegacyElementFragment,
): ElementFragment => {
  return {
    ...legacy,
    text: legacy.text
      ? elementTextFragmentFromLegacy(legacy.text)
      : legacy.text,
  }
}

export const layoutFragmentFromLegacy = (
  legacy: LegacyLayoutFragment,
): LayoutFragment => {
  return {
    ...legacy,
    category: legacy.category
      ? layoutCategoryFromLegacy(legacy.category)
      : legacy.category,
    owner: ownerFromLegacy(legacy.owner),
    dimensions: legacy.dimensions
      ? layoutDimensionsFromLegacy(legacy.dimensions)
      : legacy.dimensions,
    panel: {
      ...legacy.panel,
      elements: legacy.panel.elements.map(elementFragmentFromLegacy),
    },
  }
}

export const cardSendTypeFromLegacy = (
  legacy: LegacyCardSendType,
): CardSendType => {
  switch (legacy) {
    case LegacyCardSendType.HEARTFELT:
      return CardSendType.Heartfelt
    case LegacyCardSendType.SYSTEM:
      return CardSendType.System
  }
}

export const labeledPriceFragmentFromLegacy = (
  legacy: LegacyLabeledPriceFragment,
): LabeledPriceFragment => {
  return {
    ...legacy,
    currency: currencyTypeFromLegacy(legacy.currency),
  }
}

export const priceFragmentFromLegacy = (
  legacy: LegacyPriceFragment,
): PriceFragment => {
  return {
    ...legacy,
    currency: currencyTypeFromLegacy(legacy.currency),
  }
}

export const itemizedCostFragmentFromLegacy = (
  legacy: LegacyItemizedCostFragment,
): ItemizedCostFragment => {
  return {
    ...legacy,
    total: legacy.total.map(priceFragmentFromLegacy),
    entries: legacy.entries.map(labeledPriceFragmentFromLegacy),
  }
}

export const sendableCardFragmentFromLegacy = (
  legacy: LegacySendableCardFragment,
): SendableCardFragment => {
  return {
    ...legacy,
    cost: itemizedCostFragmentFromLegacy(legacy.cost),
  }
}

export const panelFragmentFromLegacy = (
  legacy: LegacyPanelFragment,
): PanelFragment => {
  return {
    ...legacy,
    elements: legacy.elements.map(elementFragmentFromLegacy),
  }
}

export const sendableCardWithTemplateFragmentFromLegacy = (
  legacy: LegacySendableCardWithTemplateFragment,
): SendableCardWithTemplateFragment => {
  return {
    ...legacy,
    cost: itemizedCostFragmentFromLegacy(legacy.cost),
    cardTemplate: legacy.cardTemplate
      ? {
          ...legacy.cardTemplate,
          panels: legacy.cardTemplate.panels.map(panelFragmentFromLegacy),
        }
      : legacy.cardTemplate,
  }
}

export const cardFragmentFromLegacy = (
  legacy: LegacyCardFragment,
): CardFragment => {
  return {
    ...legacy,
    type: cardTypeFromLegacy(legacy.type),
    paperType: cardPaperTypeFromLegacy(legacy.paperType),
    detailedSendableCard: legacy.detailedSendableCard
      ? {
          ...sendableCardWithTemplateFragmentFromLegacy(
            legacy.detailedSendableCard,
          ),
          variations: legacy.detailedSendableCard?.variations.map(
            sendableCardWithTemplateFragmentFromLegacy,
          ),
        }
      : legacy.detailedSendableCard,
    cost: itemizedCostFragmentFromLegacy(legacy.cost),
    panels: legacy.panels.map(panelFragmentFromLegacy),
  }
}

export const lineFragmentFromLegacy = (
  legacy: LegacyLineFragment,
): LineFragment => {
  return {
    ...legacy,
    card: legacy.card ? cardFragmentFromLegacy(legacy.card) : legacy.card,
    giftVariation: legacy.giftVariation
      ? giftVariationFragmentFromLegacy(legacy.giftVariation)
      : legacy.giftVariation,
    sendDelay: sendDelayFragmentFromLegacy(legacy.sendDelay),
    cost: itemizedCostFragmentFromLegacy(legacy.cost),
    baseCost: itemizedCostFragmentFromLegacy(legacy.baseCost),
  }
}

export const detailedOrderFragmentFromLegacy = (
  legacy: LegacyDetailedOrderFragment,
): DetailedOrderFragment => {
  return {
    ...legacy,
    sendType: cardSendTypeFromLegacy(legacy.sendType),
    lines: legacy.lines.map(lineFragmentFromLegacy),
    cost: itemizedCostFragmentFromLegacy(legacy.cost),
  }
}
